<app-manager-header
	[venue]=" venue$  | async"
	[showBack]="true"
></app-manager-header>
<div class="main">
	@if(tradeGroups$ | async; as tradeGroupsValue) {
	<div class="trade-wrapper">
		<h2>Trade Groups</h2>
		@for (tradeGroup of tradeGroupsValue; track $index) {
		<div class="trade-groups-block">
			<h3>{{tradeGroup.name.de}}</h3>
			<div class="show-active-block">
				<p class="slider">
					<span class="visible-state" [class.visible]="tradeGroup.isActive"
						>{{ tradeGroup.isActive ? 'active' : 'inactive' }}</span
					>
					<mat-slide-toggle
						(ngModelChange)="changeItemActive($event, tradeGroup)"
						[ngModel]="tradeGroup.isActive"
					></mat-slide-toggle>
				</p>
			</div>
		</div>
		}
	</div>
	}
</div>
